export const DEFAULT_TABLE_DATETIME_FORMAT = "dd/MM/yyyy";

export const DEFAULT_DATETIME_FORMAT_LOCALE = "en-US";
export const DEFAULT_DATETIME_OPTIONS = {
  day: "2-digit",
  month: "short",
  year: "numeric",
};
